import type {ConnectElementConfig} from '../ConnectElementList';

export const StripeProfileManagementConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "stripeProfileManagement" */
      '../../../components/StripeProfileManagement/StripeProfileManagement'
    ),
  htmlEvents: ['onprofilesaved'],
  customHtmlElementMethods: {
    setDefaultValues: {
      type: 'SupplementalObject',
      objectToSet: 'stripeProfileDefaultValues',
      isInternal: false,
      description:
        'Sets editable default values used when creating a Stripe profile.',
    },
    setOnProfileSaved: {
      type: 'EventListenerMethod',
      event: 'onprofilesaved',
      isInternal: false,
      description:
        'Sets a callback that runs after a Stripe profile is created or updated.',
    },
  },
  releaseState: 'internal',
  requiresAuthentication: true,
  sentryTeam: 'connect_marketplaces',
  teamOwner: 'connect-integrations',
  description:
    'Allows connected accounts to create or edit their Stripe profile',
  friendlyName: 'Stripe profile management',
};
